import api from "./api";
import endpoints from "./endpoints";

export default {
  getPriceAttributes: async function (languageCode) {
    const result = await api.get(endpoints.attributeManager.priceAttributes.get, {
      params: { languageCode }
    });
    return result.data;
  },
  updatePriceAttributes: async function (args) {
    const result = await api.post(endpoints.attributeManager.priceAttributes.update, args, { params: {} });
    return result.data;
  }
};
